import { render } from "./TrainingCertificateList.vue?vue&type=template&id=4b312932&ts=true"
import script from "./TrainingCertificateList.vue?vue&type=script&lang=ts"
export * from "./TrainingCertificateList.vue?vue&type=script&lang=ts"

import "./TrainingCertificateList.vue?vue&type=style&index=0&id=4b312932&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__